export default "__VITE_ASSET__1cbfb828__"